import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField,TimePicker,DatePicker,Grid,Cell,SelectionControl } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import restoreQuestionBankHandler from '../component/ArchiveRestoreAPI';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import UserAccessDetails from '../lib/UserAccessDetails';
import { AppSetting, AppProperties,ADMIN_USER_ROLE } from '../common/function';
import moment from 'moment';
import MomentTz from 'moment-timezone';
import ReactTooltip from 'react-tooltip';
import QBDeleteDialog from './dialogs/QBDeleteDialog.jsx';
import { QBSyncInUseByLibraryDialog } from './AssignmentMatrixLibrary/LibrarySync';
import {  Tooltip, Typography } from '@mui/material';
import { MenuItem,Select,IconButton } from '@mui/material';
import { BsInfoCircleFill } from "react-icons/bs";
import { getRandomColorForSubjectMatrix, generateLabelForName,SubjectColorPalette } from '../component/vectors/commonHelpers';
import QBExplanationHeader from '../component/QBExplanationHeader.js';
import { TbRefresh } from "react-icons/tb";






let subject = {
  subject_name: '',
  subject_id: '',
  default_color: getRandomColorForSubjectMatrix(),
  subject_color :"",
};

const isValidDate = function(d) {
  return d instanceof Date && !isNaN(d);
}


export default class Subjects extends Component {
  userAccessDetails = new UserAccessDetails();
  AppSetting = AppSetting();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  
  constructor(props) {
    super(props);

    
    this.state = {
      subjects: [],
      temp_subject: subject,
      temp_id: '',
      visible: false,
      addMode: true,
      loading: true,
      synloading:true,
      redirectLoading:false,
      readOnly:this.props.archive_mode || this.props.location.query.archive_mode === 'true',
      archive_mode:this.props.archive_mode ||this.props.location.query.archive_mode === 'true',
      instructor_name: window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instSubjects:[],
      currSubject:false,
      countOfTCSQ:[],
      countLoading:false,
      explanationCountMap:{}, // key is subject_id
      subjectSyn:[],
      syncAccess:false,
      synConform:false,
      synIndex:null,
      AllSubForSuperadmin:false,
      SyncscheduleDate: "",
      _userAccessDetails: JSON.parse(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`)),
      univTimeZone :window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`),

      showDeleteDialog: false,
      deleteData: null,
      deleteIndex: -1,
      // The library matrices that refused this subject's sync being switched
      // off; null while there is nothing to show.
      blockingLibraryMatrices: null,
      colorQueue: this.buildShuffledColorQueue(),
    };
    
    this.deleteSubject = this.deleteSubject.bind(this);
    this.addSubject = this.addSubject.bind(this);
    this.getAllSubjects = this.getAllSubjects.bind(this);
    this.changeSubjectName = this.changeSubjectName.bind(this);
    this.changeSubjectColor = this.changeSubjectColor.bind(this);
    this.changeSubjectAbbreviation = this.changeSubjectAbbreviation.bind(this);
    this.updateSubject = this.updateSubject.bind(this);
    
    this.isEnterPressed = this.isEnterPressed.bind(this);    
    this.getCountOfTCSQ = this.getCountOfTCSQ.bind(this);
    this.onEnableSync = this.onEnableSync.bind(this);  
    this.onDisableSync = this.onDisableSync.bind(this)  
    this.onHandleRedirect = this.onHandleRedirect.bind(this)

    this.handleScheduleDate = this.handleScheduleDate.bind(this)
    this.onSyncSchedule = this.onSyncSchedule.bind(this)
    
    // this.errorMessageHide= this.errorMessageHide.bind(this);
  }

  componentWillMount() {
    console.debug('componentwiollmount')
       this.setState({ loading: true,synloading:true });
      
      this.getAllSubjects(this.props);
      this.getSyncSwitchAccess()
      
    if(this.state.userprofilerole === 2){
      this.setState({
        currSubject:true
      })
    }
    
  }
  randomColorPicker = () => {
    let { colorQueue, topic_color } = this.state;

    if (colorQueue.length === 0) {
      colorQueue = this.buildShuffledColorQueue();
    }

    if (colorQueue.length > 1 && colorQueue[0].bg === topic_color) {
      colorQueue = [...colorQueue.slice(1), colorQueue[0]];
    }

    const next = colorQueue[0];
    const rest = colorQueue.slice(1);
    let curSubjectName = this.state.temp_subject;
    curSubjectName.subject_color =next.bg;
    this.setState({
      colorQueue: rest,
      temp_subject: curSubjectName,
    });
  };
  getAllSubjects(){
    console.debug('getAllSubjects');
    
   
    this.userAccessDetails.getAllSubjects(this.state.archive_mode).then(subjects=>{
      this.userAccessDetails.getSubjectsByInstructor().then(subjectsByIns => {
        this.setState({
          subjects,
          instSubjects : subjectsByIns,
          loading: false
        });

        //subject Sync
        this.getAllSubjectSync();
      }).catch(err=>{
        console.error('ERROR : ', err);
        NotificationManager.error(err, 'ERROR', 3000);
        this.setState({ loading: false });
        this.hide();
      });
    }).catch(err=>{
      console.error('ERROR : ', err);
      NotificationManager.error(err, 'ERROR', 3000);
      this.setState({ loading: false });
      this.hide();
    }); 
    this.getCountOfTCSQ();
    
  }
  /*componentWillMount() {
    this.getAllSubjects(this.props);
    this.getCountOfTCSQ();   
  }*/

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }

  buildShuffledColorQueue = () => {
      return [...SubjectColorPalette]
        .map(x => ({ ...x, k: Math.random() }))
        .sort((a, b) => a.k - b.k)
        .map(x => ({ bg: x.bg, name: x.name }));
};


  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };

  componentWillReceiveProps(nextProps) {
   }

  addBreadCrumbs = () => {
    if(this.state.archive_mode === true){
      this.props.replaceBreadCrumb([
        { name: 'All Subjects', type: '', onclickPath: '/archivePage' }
      ]);
    }else{
      this.props.replaceBreadCrumb([
        { name: 'All Subjects', type: '', onclickPath: '/subjects' }
      ]);
    }
    

  };

  getCountOfTCSQ  (){
    console.debug('getCountOfTCSQ :' + this.state.temp_subject.subject_id);
    this.setState({ countLoading: true });
    const payload = {
      subject_id : 0,
      topic_id : 0 ,
      category_id : 0,
      subcategory_id : 0 
    }

    ApiRequestService({
      method: 'post',
      url: '/getCountOfTCSQ',
      data: payload
    }).then(res => {
      if(res.data && res.data.data && res.data.data.CountOfTCSQ ){
        console.debug(res);
        console.debug('getCountOfTCSQ State: ');
        this.setState({
          countOfTCSQ : res.data.data.CountOfTCSQ,
          explanationCountMap: res.data.data.ExplanationCountMap
        });
      }
    }).finally(() => {
      this.setState({ countLoading: false });
    });
  }
  componentWillUpdate() {
    this.addBreadCrumbs();
  }

  getAllSubjectSync = () => {

    //If Super Admin
    if ( this.state.userprofilerole === 2 && (this.state.syncAccess)){

    
        ApiRequestService({
          method:'post',
          url:'/getAllSubjectSync'
        }).then(res => {
          let syndata = res.data.data.subject_names 
          let tempAllSubjects = this.state.subjects
    
          for(let sub of tempAllSubjects) {
            for(let syn of syndata) {
              if (sub.subject_id == syn.subject_id ) {
                sub.enable_sync = syn.enable_sync
                sub.some_sync = syn.some_sync
                sub.sync_status = syn.sync_status
              }
            }
          }
    
          this.setState({
            topics: tempAllSubjects,
            synloading: false ,
            subjectSyn:syndata
          });
        }).catch (err => {
          this.setState({
            synloading:false
          })
        })
  
    }
    

  }
  addSubject() {
    console.debug('Add subject :' + this.state.temp_subject.subject_name);
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    if (
      this.state.temp_subject.subject_name === null ||
      this.state.temp_subject.subject_name.trim() === ''
    ) {
      alert('Please enter a valid "Subject name"');
      return;
    }
    this.setState({ loading: true });
    var tempSubject = this.state.temp_subject.subject_name.trim();
    const payload = {
      subject_name: tempSubject,
      subject_color:this.state.temp_subject.subject_color,
      short_form:this.state.temp_subject.short_form ? this.state.temp_subject.short_form : generateLabelForName(tempSubject),
    };
    ApiRequestService({
      method: 'post',
      url: '/addSubject',
      data: payload
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        console.error('ERROR : ', res.data.message);
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.hide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }

      if (res.data.data != null) {
        
        var tempSubject = this.state.subjects;
        var tempSubId = res.data.data.subject_id
        var tempInsSubject = this.state.instSubjects
         tempInsSubject[tempSubId] = true;
        console.debug("tempInsSubject ",tempInsSubject);
        tempSubject.push({
          subject_name: res.data.data.subject_name,
          short_form: res.data.data.short_form,
          subject_color: res.data.data.subject_color,
          subject_id: res.data.data.subject_id,
          enable_sync: res.data.data.enable_sync,
          some_sync:res.data.data.some_sync,
          sync_status: res.data.data.sync_status,
          sync_validation: res.data.data.sync_validation
        });
        this.state.countOfTCSQ.push({
          number_of_topics:0,
          number_of_categories: 0,
          number_of_subcategories:0,
          number_of_questions:0
        })
          this.setState({
            subjects: tempSubject,
            instSubjects:tempInsSubject,
            synloading:false,
            countOfTCSQ:this.state.countOfTCSQ
          });
          this.userAccessDetails.addSubject(res.data.data.subject_id);
          
      }
      this.setState({
        loading: false
      });
      this.hide();
    });
   // this.getCountOfTCSQ();
    
  }
  // errorMessageHide(){
  //     console.debug("errorType");
  //     var tempErrortype = "";
  //     var tempErrorMessage = "";
  //     this.setState({
  //         errorMessage: tempErrortype,
  //         errorType:tempErrortype,
  //     })

  // }
  editSubject(id) {
    let curSubject = {...this.state.subjects[id]}
    if (curSubject.short_form === null || curSubject.short_form === undefined || curSubject.short_form === '') {
      curSubject.short_form = generateLabelForName(curSubject.subject_name)
    }
    if (curSubject.subject_color === null || curSubject.subject_color === undefined || curSubject.subject_color === '') {
      curSubject.default_color = getRandomColorForSubjectMatrix()
      curSubject.subject_color = ""
    }
    this.setState({
      temp_subject: curSubject,  
      temp_id: id,
      addMode: false
    });
    this.show(false);
  }
superAdminSyncSubValidation ()  {
    this.setState({
      AllSubForSuperadmin: !this.state.AllSubForSuperadmin
    });
  }
  updateSubject() {
    this.setState({ loading: true });
    console.debug('Editing subject :' + this.state.temp_subject.subject_id);

    const payload = this.state.temp_subject;

    ApiRequestService({
      method: 'post',
      url: '/updateSubject',
      data: payload
    }).then(res => {
      console.debug(res);
      //this.state.subjects[this.state.temp_id] = payload
      console.debug('UpdateSubject State: ', this.state.subjects);
      this.setState({
        subjects: this.state.subjects,
        temp_subject: subject,
        loading: false
      });
      this.hide();
    });
  }


  getSyncSwitchAccess = () => {
    //if userprofile is admin 
    if ( this.state.userprofilerole === ADMIN_USER_ROLE){
        ApiRequestService({
          method:'post',
          url:'/syncSwitch'
        }).then(res => {
          let syncAccess = res.data.data
 
          if (syncAccess) {

            this.setState({
              syncAccess:true
            });
          }
        }).finally (err => {
          this.setState({
            synloading:false
          })
        })
  
    }
  }
  deleteSubject(id) {
    this.setState({ loading: true });
    console.debug(
      'Deleting subject i:' + id + ' id: ' + this.state.subjects[id].subject_id
    );
    const payload = {
      subject_id: this.state.subjects[id].subject_id,
      archive_mode:this.state.archive_mode
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteSubject',
      data: payload
    })
      .then(res => {
        let delSubjectId = this.state.subjects[id].subject_id
        console.debug(res);
        //window.localtion.reload();
        this.state.subjects.splice(id, 1);
        console.debug('Spliced Array', this.state.subjects);
        this.state.countOfTCSQ.splice(id, 1);
        this.setState({
          countOfTCSQ:this.state.countOfTCSQ,
          subjects: this.state.subjects,
          loading: false,

          showDeleteDialog: false,
          deleteData: null,
          deleteIndex: -1,
        });
        this.userAccessDetails.removeSubject(delSubjectId);
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete subject',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  changeSubjectName(e) {
    let curSubjectName = this.state.temp_subject;
    let shortForm  = generateLabelForName(e);
    curSubjectName.subject_name = e;
    curSubjectName.short_form = shortForm;
    this.setState({
      temp_subject: curSubjectName
    });

  }
  changeSubjectAbbreviation(e) {
    let curSubjectName = this.state.temp_subject;
    curSubjectName.short_form = e.toUpperCase().slice(0, 2);
    
    this.setState({
      temp_subject: curSubjectName
    });
  }
  changeSubjectColor(e) {
    let curSubjectName = this.state.temp_subject;
    let colorName = e.target.value;
    if (colorName === "") {
       curSubjectName.default_color = getRandomColorForSubjectMatrix();
    }
    curSubjectName.subject_color = colorName;
    this.setState({
      temp_subject: curSubjectName,
    });
  }
  show = isSubjectEnable => {
    //

    if (isSubjectEnable) {
      console.debug('Add button click');
      this.setState({
        temp_subject: {
          subject_name: '',
          subject_id: '',
          subject_color :"",
          default_color: getRandomColorForSubjectMatrix(),
        }
      });
    }
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  subjPage() {
    browserHistory.push(this.baseFolder + 'subjects');
  }
  delete = id => {
    
    this.setState({
      showDeleteDialog: true,
      deleteIndex: id,
      deleteData: {
        ...this.state.subjects[id],
        deleteType: "Subject",
      }
    })

    // confirmAlert({
    //   title: 'Are you sure want to delete this subject ?',
    //   message: 'Press Confirm to submit',
    //   confirmLabel: 'Cancel',
    //   cancelLabel: 'Confirm',

    //   onCancel: () => this.deleteSubject(id)
    //   //   onCancel: () => ,
    // });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
        this.addSubject()
        } else {
        this.updateSubject()
      } 
    }
  }

  onConformDialog = (index) => {
    this.setState({
      synConform:true,
      synIndex:index
    })
  }
  onConformDialogCancel = () => {
    this.setState({
      synConform:false,
      synIndex:null
    })
  }
  onEnableSync = (index)=>{
    this.setState({loading:true});
    const payload = {
      subject_id: this.state.subjects[index].subject_id,
      enable_sync:true,
      from_qb: true
    };

    // LTI sync disable
    if( this.appProperties.enableLTI ) {
      this.setState({
        loading: false,
        synConform:false,
        synIndex:null
      });
      return
    }

    //check empty subject
    let subCountOfTCSQ = this.state.countOfTCSQ[index]
    if (subCountOfTCSQ.number_of_topics == 0) {
      NotificationManager.error(
        'Error',
        'Unable To Sync Empty Subject. Please Add Topic And Try Again',
        5000
      );

      this.setState({
        loading: false,
        synConform:false,
        synIndex:null
      });
      return
    }
   
    ApiRequestService({
      method: 'post',
      url: '/sync/enableSync',
      data: payload
    })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false,
            synConform:false,
            synIndex:null
          });
        }
        
        if(res.data && res.data.status === 0){

          let tempArray = [...this.state.subjects];
          tempArray[index].enable_sync = payload.enable_sync;
          if (tempArray[index].some_sync) {
            tempArray[index].some_sync = !tempArray[index].some_sync
          }
          this.setState({
            subjects:tempArray,
            loading: false,
            synConform:false,
            synIndex:null
          });
        }

        
      })
      .catch(error => {
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to edit subject',
            5000
          );
        }
        this.setState({
          loading: false,
          synConform:false,
          synIndex:null
        });
      });
  }


  handleScheduleDate (timeString, sDate, event){
    if (sDate !== null) {
      this.setState({
        SyncscheduleDate: moment(sDate)
      });
    }
  }

  onSyncSchedule = (index) => {
    this.setState({loading:true});

    let univTime = this.state.univTimeZone
    let sDate = this.state.SyncscheduleDate

    if (sDate == "") {
      NotificationManager.error("Please Enter A Valid Date And Time", 'ERROR', 3000);
        this.setState({
          loading: false,
          synConform:false,
          synIndex:null
        });
        return
    }
    let dateWithoutZone = moment(sDate).format("YYYY-MM-DDTHH:mm:ss.SSS")
    let otherZone = moment.tz(sDate, univTime).format("Z")
    let dateWithOtherZone = [dateWithoutZone, otherZone].join("")
    let NewScheduledate = new Date(dateWithOtherZone)
    let scheduledTimeInUTC = moment(NewScheduledate).utc()
    
    const payload = {
      subject_id: this.state.subjects[index]?.subject_id,
      enable_sync:true,
      from_qb: true,
      syncDate: scheduledTimeInUTC,
    };

    ApiRequestService({
      method: 'post',
      url: '/syncSchedule',
      data: payload
    })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false,
            synConform:false,
            synIndex:null
          });
        }

        if(res.data.data) {
          NotificationManager.success("Sync Scheduled","Success",3000);
        } 
        
        this.setState({
          loading: false,
          synConform:false,
          synIndex:null
        });
        
    

        
      })
      .catch(error => {
        this.setState({
          loading: false,
          synConform:false,
          synIndex:null
        });
      });
  }
  onHandleRedirect = (subject) => {

    let subjectRedirect = subject.subject_id
    if ((this.state.instSubjects && !(this.state.instSubjects[subjectRedirect] === true) || this.appProperties.enableLTI)) {
      let navigatePage = `topics?subject_id=${subject.subject_id}`+
      `&subject_name=${subject.subject_name}`+
      `&archive_mode=${this.state.archive_mode}`+
      `&archive_id=1`

      this.setState({
        loading: true,
        redirectLoading:true
      });
      //fetch  source redirect url 

     let  payload = {
        subject_id: subjectRedirect
      }
      ApiRequestService({
        method: 'post',
        url: '/sourceUnivUrl',
        data: payload
      })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false,
            redirectLoading:false
          });
        }
        
        
        if(res.data && res.data.status === 0){
          let response = res.data.data
          let soucreBase= response.REACT_APP_URL
          let sourceURL = soucreBase + navigatePage
          //source univ navigate
          window.open(sourceURL, '_blank');
          //navigate current Page
          browserHistory.push(this.appProperties.baseFolder + navigatePage);
          this.setState({
            loading: false,
            redirectLoading:false
          });
        }

        
      }).catch((err)=> {
        console.debug("error from source univ url",err)

        this.setState({
          loading: false,
          redirectLoading:false
        });
      })

    }

  }
  onDisableSync = (index)=>{
    this.setState({loading:true});
    const payload = {
      subject_id: this.state.subjects[index]?.subject_id,
      enable_sync:false,
      from_qb: true
    };

    // LTI sync disable
    if( this.appProperties.enableLTI ) {
      this.setState({
        loading: false
      });
      return
    }
    
    ApiRequestService({
      method: 'post',
      url: '/sync/enableSync',
      data: payload
    })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false
          });
        }
        
        
        if(res.data && res.data.status === 0){

          // Refused: a library matrix that is syncing depends on a category
          // in this subject. Nothing was written, so the toggle stays on and
          // the matrices holding it there are named.
          const usage = res.data.data;
          if (usage && usage.valid === false) {
            this.setState({
              blockingLibraryMatrices: usage.library_matrices || [],
              loading: false
            });
            return;
          }

          let tempArray = [...this.state.subjects];
          tempArray[index].enable_sync = payload.enable_sync;
          if (tempArray[index].some_sync) {
            tempArray[index].some_sync = !tempArray[index].some_sync
          }
          this.setState({
            subjects:tempArray,
            loading: false
          });
        }

        
      })
      .catch(error => {
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to edit subject',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }

  render() {
    let button = null;
    let synButton = null;
    let schedulebtn = null;
    let syncScheduleDateLocal =  moment(this.state.SyncscheduleDate).toDate();
   if(!this.state.archive_mode && this.state.addMode){
      
        button = (
          <Button style={styles.addButton} onClick={this.addSubject}>
            Add Subject
          </Button>
        );
        synButton = (
          <Button style={styles.addButton} onClick={() => {this.onEnableSync(this.state.synIndex)}}>
            Turn On Now
          </Button>
        );
        schedulebtn = (
          <Button style={styles.addButton} onClick={() => {this.onSyncSchedule(this.state.synIndex)}}>
            Schedule
          </Button>
        )
      } else {
        button = (
          <Button style={styles.addButton} onClick={this.updateSubject}>
            Update Subject
          </Button>
        );
      }
    
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={()=>{
        this.hide()
        this.onConformDialogCancel()
      }}>
        Cancel
      </Button>
    );

    const actions = [];
    const syncActions = [];
    syncActions.push(synButton)
    syncActions.push(schedulebtn)
    syncActions.push(cancelButton)
    actions.push(button);
    actions.push(cancelButton);
    var tableRows = (this.state.subjects != null && this.state.countOfTCSQ != null
      ? this.state.subjects.map((subject, i) => {
       if (subject.sync_validation || this.state.AllSubForSuperadmin) {
        return(
          <TableRow
            key={subject.subject_id}
            data={subject}
            id={subject.subject_id}
            name={subject.subject_name}
            title={'Subjects'}
            type={''}
            url={
              'topics?subject_id=' +
              subject.subject_id +
              '&subject_name=' +
              subject.subject_name+
              '&archive_mode='+
              this.state.archive_mode+
              '&archive_id='+
              1
            }
            onEditClick={() => this.editSubject(i)}
            pushId={'subject'}
            onDeleteClick={() => this.delete(i)}
            instructorSubject={( this.state.instSubjects && this.state.instSubjects[subject.subject_id] === true)}
            show_archive_actions={this.state.archive_mode}
            onArchiveRestoreClick={()=>this.onArchiveRestoreClick(subject)}
            countOfTCSQ={this.state.countOfTCSQ !== undefined && this.state.countOfTCSQ !== null ? this.state.countOfTCSQ[i] : null}
            countLoading={this.state.countLoading}
            explanationMap={this.state.explanationCountMap ? this.state.explanationCountMap[subject.subject_id] : {}}
            onEnableSync={() => this.onConformDialog(i)}
            onDisableSync={() => this.onDisableSync(i)}
            onHandleRedirect={()=> this.onHandleRedirect(subject)}
            syncEnabled={subject.enable_sync}
            someSyncEnabled={subject.some_sync}
            synloading={this.state.synloading}
            rowIndex={i}
            syncSwitch={this.state.syncAccess}
          />)
        }
      })
      : '')

    return (

      (this.state.loading)?
      <div>

          {
             this.state.redirectLoading ? <p style={{ 
              display: "flex" ,justifyContent: "center",
              color:"#bb0000",fontSize:"20px",fontWeight:"500"
              }}>
                Redirecting to Source University, Please wait...</p> : " "
          }
        <div   style={{ marginTop:"-261px"}}  >
          <LoadingSpinner loading={this.state.loading} />
        </div>
      </div>
      :
      <SecureShow targetRole={1}>

          <QBSyncInUseByLibraryDialog
            scope="subject"
            libraryMatrices={this.state.blockingLibraryMatrices}
            onClose={() => this.setState({blockingLibraryMatrices: null})}
          />

          <QBDeleteDialog 
            showDialog={this.state.showDeleteDialog}
            data={this.state.deleteData}
            handleClose={() => this.setState({showDeleteDialog: false, deleteData: null, deleteIndex: -1})}
            handleDelete={() => {
              if (this.state.deleteIndex > -1) {
                this.deleteSubject(this.state.deleteIndex);
              }
            }}
        />

        <div style={{ width: '100%' ,marginTop:"120px"}} className="subjectDivContainer">
          <div style={styles.subjectTitle} className="subjectDivClass">
            <strong>Subjects</strong>

            {this.state.userprofilerole ===2 && (!this.appProperties.enableLTI) ? (
              !this.state.readOnly  ?
                <div style={styles.syncvalidationSwitch}>
                  {
                    this.state.syncAccess ? 
                    <div>
                      
                    <SelectionControl 
                    id={"syncsubhideswitch"}
                    type="switch"
                    name="syncHide"
                    label={null}
                    checked={this.state.AllSubForSuperadmin}
                    onChange={() => this.superAdminSyncSubValidation()}
                    style={{float: 'none', display: 'inline-block',top:"-8px",position:"relative"}}
                    data-tip data-for='test-mode-sync'
                    />
                    <ReactTooltip id={'test-mode-sync'} type='light' className='tool-tip'>
                      <span>{'View As super Admin to show all subject'}</span>
                    </ReactTooltip> 
                    </div>
                    : ""
                  }
                  <Button className="archive-button" primary raised 
                    onClick={() => this.show(true)}>
                    Add a New Subject
                  </Button>
                </div>
              :
                null
              )
              :null
            }
            
          </div>
          <div>
            {
              <DialogContainer
                id="simple-action-dialog"
                visible={this.state.visible}
                onHide={this.hide}
                actions={actions}
                style={{ paddingBottom: '0px' }}
                width="500px"
              >
                <p style={{ fontSize: "medium" }}>
                  <b><label htmlFor="subId">{this.state.addMode ? "New" : "Edit"} Subject</label></b>
                </p>

                <div style={{ marginBottom: 16,marginTop:30 }}>
                  <label htmlFor="subId" style={{ fontWeight: 500, display: "block", marginBottom: 4 }}>
                    Subject Name
                  </label>
                  <TextField
                    id="subId"
                    name="subject_name"
                    value={this.state.temp_subject.subject_name || ''} 
                    onChange={this.changeSubjectName}
                    onKeyPress={this.isEnterPressed.bind(this)}
                    className="md-cell md-cell--12"
                    style={{ marginLeft: '0px' }}
                    placeholder="Enter subject name"
                  />
                </div>

                <div className="md-grid"  style={{ marginLeft: '0px',paddingLeft:'0px' }}>
                  <div className="md-cell md-cell--3" style={{ marginLeft: '0px' }}>
                    <div className="button-flex" style={{ display: "flex", alignItems: "center" }}>
                      <label htmlFor="abbrId" style={{ fontWeight: 500, display: "block", marginBottom: 4 }}>
                        Label
                      </label>
                      <div>
                      <span
                            style={{
                                float: 'none', display: 'inline-block',top:"-2px",position:"relative" 
                            }}
                            data-tip data-for='subject-label-helptext'
                          >
                            <BsInfoCircleFill
                              color="#737373"
                              size={14}
                              style={{
                                flexShrink: 0,
                                verticalAlign: "middle",
                              }}
                            />
                          </span>
                        <ReactTooltip id={'subject-label-helptext'} type='light' className='tool-tip'>
                          <span>{'Abbreviation of the subject'}</span>
                        </ReactTooltip> 
                      </div>
                    </div>
                    <TextField
                      id="abbrId"
                      name="abbreviation"
                      value={this.state.temp_subject.short_form  }
                      onChange={this.changeSubjectAbbreviation}
                      placeholder="Ex: CS"
                      style={{ width: "60px", textTransform: "uppercase",marginLeft: '0px' }}
                    />
                  </div>

                  {/* Color Picker */}
                  <div className="md-cell md-cell--9"  style={{ marginLeft: '0px' }}>
                    <div className="button-flex" style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ fontWeight: 500, marginRight: 4 }}>
                        Subject Color
                      </label>
                      <div>
                      <span
                            style={{
                                float: 'none', display: 'inline-block',top:"-2px",position:"relative" 
                            }}
                            data-tip data-for='subject-color-helptext'
                          >
                            <BsInfoCircleFill
                              color="#737373"
                              size={14}
                              style={{
                                flexShrink: 0,
                                verticalAlign: "middle",
                              }}
                            />
                          </span>
                        <ReactTooltip id={'subject-color-helptext'} type='light' className='tool-tip'>
                          <span>{'Pick a color to represent the subject in Assignment Matrix'}</span>
                        </ReactTooltip> 
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" ,marginTop:"10px"}}>
                      <div
                        className="stackable-icon stackable-subject-icon"
                        style={{
                          backgroundColor:
                            this.state.temp_subject.subject_color === "" ? this.state.temp_subject.default_color  :
                            this.state.temp_subject.subject_color,
                          width: "35px",
                          height: "28px",
                          borderRadius: "50%",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          marginRight: 8,
                        }}
                      >
                        {this.state.temp_subject.short_form || generateLabelForName(this.state.temp_subject.subject_name)}
                      </div>

                      <Select
                        value={this.state.temp_subject.subject_color || ""}
                        onChange={this.changeSubjectColor}
                        fullWidth
                        style={{ height: 30, borderRadius: 4 }}
                        displayEmpty
                         MenuProps={{
                          disableScrollLock: true,
                        }}
                      >
                        {SubjectColorPalette.map((color) => (
                          <MenuItem key={color.value} value={color.bg}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div
                                style={{
                                  width: 16,
                                  height: 16,
                                  borderRadius: "50%",
                                  background: color.bg,
                                  marginRight: 8,
                                }}
                              />
                              {color.name}
                            </div>
                          </MenuItem>
                        ))}
                      </Select>
                          <span
                            data-tip data-for='subject-random-color-helptext'
                          >
                              <IconButton aria-label="edit" onClick={(e) => {
                                  this.randomColorPicker();
                              }}>
                                  <TbRefresh color='#bb0000' />
                              </IconButton>
                            
                          </span>
                          <ReactTooltip id={'subject-random-color-helptext'} type='light' className='tool-tip'>
                          <span>{'Random Color'}</span>
                        </ReactTooltip> 
                    </div>
                  </div>
                </div>
              </DialogContainer>
            }
          </div>
          <table style={styles.subjectTable}  className="subjectTableClass">
            <thead style={styles.thead} className="subjectTableHeadClass">
              <tr>
                <th>ID</th>
                <th style={{textAlign:'left',paddingLeft:'25px'}}>Subjects</th>
                {/* <th colSpan="5">Total Number Of </th> */}
                <th>Topics</th>
                <th>Categories</th>
                <th>SubCategories</th>
                <th>Questions</th>
                <th>
                  <QBExplanationHeader name="subject" />
                </th>
                {
                   !this.appProperties.enableLTI ? 
                   <th>Actions</th> : ''
                }
              </tr>
              {/* <tr>
                <th></th>
                <th></th>
                <th>Topics</th>
                <th>Categories</th>
                <th>SubCategories</th>
                <th>Questions</th>
                <th>Explanations</th>
                <th></th>
              </tr> */}
            </thead>

            <tbody className="subjectTableBodyClass">
              {tableRows}
            </tbody>
          </table>
        </div>
        {!this.appProperties.enableLTI ? 
            <div >
            <DialogContainer
                  id="TurnSyncDialog"
                  visible={this.state.synConform}
                  onHide={this.onConformDialogCancel}
                  actions={syncActions}
                //  title="Sync"
                  width="50%"
                  height="50%"
                  
                  key="AddInstructorDialog"
                  >

                  <div  style={{top:"50% !important"}}>
                  <div>
                      <div style={{display:"flex",justifyContent: "space-between"}}>

                        <h2> <label for="semId">{'Subject Sync'}</label></h2>
                        <Button  icon onClick={this.onConformDialogCancel}>
                            close
                        </Button>
                
                      </div>
                      <div>
                        <strong>
                          Are you sure, you want to turn on subject sync ?
                        </strong>

                      
                      </div>
                      <div>
                          <Grid style={{width:'100%'}}>

                            <Cell size={6} phoneSize={4} tabletSize={8}>
                              <DatePicker
                                      id="sstartDate"
                                      label="Start Date"
                                      displayMode="default"
                                      value={isValidDate(syncScheduleDateLocal)?syncScheduleDateLocal:""}
                                      onChange={this.handleScheduleDate}
                              />
                            </Cell>
                            <Cell size={6} phoneSize={4} tabletSize={8}>
                                <TimePicker
                                        id="sstartTime"
                                        label="Start Time"
                                        displayMode="default"
                                        value={isValidDate(syncScheduleDateLocal)?syncScheduleDateLocal:""}
                                        onChange={this.handleScheduleDate}

                                />  
                            </Cell>
                      </Grid>
                      </div>
                        
                        <p style={{marginTop:"30px"}}>
                            Note:  Please note that this may cause downtime. We recommend scheduling a sync schedule during off-peak hours.
                        </p>
                    </div>
            </div>
            </DialogContainer>
            </div>
        
         :""
        }
        <center>
          {
            !this.appProperties.enableLTI ? 
            <div style={this.state.instSubjects ? {display:"none"}:{width:"35%"}}className='image-resize-warning'>
            <p><b>Note :</b> Contact Administrator to gain access to edit this page.</p>
            </div> : " "
          }
      
        {
          this.appProperties.enableLTI  ? 
          <div style={{width:"35%",marginTop:"10px"}} className='image-resize-warning'>
          <p><b>Note :</b> No one can make any changes in the LTI version. Please go to the OSU core question bank to make changes</p>
          </div> : " "
        }
        </center>
      </SecureShow>
    );
  }

  //Archive Restore
  onArchiveRestoreClick = (subject) => {
    let payload = {
      subject_id:subject.subject_id
    };
    restoreQuestionBankHandler(payload);
  }
}
